<main class="main-container">
    <section *ngIf="userType == 'estate-agent'" class="content">
        <h1 class="heading">Introduction For Agents</h1>
        <div class="section">
            <b>First time here?</b><br>
            If you haven't watched the intro video yet, take 5 minutes before registering — It'll show you exactly how
            everything works and help you get the most out of Property Matrix.
        </div>
        <div class="section">
            <div class="video-player-container mt-3 text-center">
                <iframe width="768" height="432" src="https://www.youtube.com/embed/Q1it0WCPyU0"
                    title="Onboarding all brokers, agents and agencies" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
        </div>
        <div class="section">
            <div class="text-center mt-3">
                <button mat-button (click)="proceed()" class="button-proceed heading-4 uppercase">
                    Proceed
                </button>
            </div>
        </div>
    </section>

    <section *ngIf="userType == 'urban-planner'" class="content">
        <h1 class="heading">Introduction For Planners</h1>
        <div class="section">
            <span class="title uppercase">This video answers:</span>
            <ul class="list-items">
                <li>Why Property Matrix? <span class="coral-text">(The Need)</span></li>
                <li>What is Property Matrix <span class="coral-text">(The Solution)</span></li>
                <li>Why Professional Planners? <span class="coral-text">(The Network)</span></li>
            </ul>
        </div>
        <div class="section">
            <span class="title">Click on play before you proceed with the registration process.</span>
            <div class="video-player-container mt-3 text-center">
                <iframe width="768" height="432" src="https://www.youtube.com/embed/ERlKCe097PI"
                    title="Introduction to Property Matrix for Network Planners" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
        </div>
        <div class="section">
            <div class="text-center mt-3">
                <button mat-button (click)="proceed()" class="button-proceed heading-4 uppercase">
                    Proceed
                </button>
            </div>
        </div>
    </section>
</main>